import { IApiActionResult } from "src/~api/ApiActionResult";
import { IAudit } from "../~store/models/Audit";
import { ConvertFromFilterToAuditStatus } from "../helpers/audit-helper";
import { fetchPost, getApiActionResult } from "src/~api/ApiHelper";
import { GET_AUDITS_API_ROUTE } from "./apiRoutes";
import { ISearchingTag, TagName, TagType } from "src/app/shared/components/tag-searching-input/~types/models/SearchingTag";
import { ConvertFromFilterToUTCTimeInterval } from "src/app/shared/helpers/date-helper/FromFilterToDateHelper";
import i18n from "src/app/shared/localization/i18n";
import { toApiSearchingTags } from "src/app/shared/helpers/api-body-helper/searchInputHelper";

export const getAuditsByTagsAsync = async (skip: number, take: number, tags: ISearchingTag[]): Promise<IApiActionResult<IAudit[]>> => {
    tags.filter(val => val.tagName === TagName.Date && val.tagType === TagType.ClosingTag && val.value !== i18n.t('common.period')).forEach(el => el.externalValue = ConvertFromFilterToUTCTimeInterval(el.value));
    tags.filter(val => val.tagName === TagName.Status && val.tagType === TagType.ClosingTag).forEach(el => el.externalValue = ConvertFromFilterToAuditStatus(el.value));
    const fetchPromise = fetchPost(GET_AUDITS_API_ROUTE, {
        body: JSON.stringify({
            skip,
            take,
            tags: toApiSearchingTags(tags)
        })
    });
    return await getApiActionResult(fetchPromise, true);
};